import React, { useState } from 'react';
import classNames from 'classnames';

import { formatCurrency } from '~libs/dataUtils';

import Icon, { faChevronDown, faChevronRight } from '~components/icon';
import { TableView } from '~components/table-view-v3';

import { ReconClient } from '~support-at-home/models';

import { columns } from '~support-at-home/forms/reconciliations/clientSummaryList';

import StatusTag from './StatusTag';

interface ComponentProps {
  client: ReconClient;
}

const ClientCard: React.FC<ComponentProps> = ({ client }) => {
  const {
    client_id,
    full_name,
    status,
    services_count,
    total_gov_contribution_amount,
    total_co_contribution_amount,
    total_claimed,
    total_paid,
    items,
  } = client;
  const [open, setOpen] = useState(false);

  return (
    <div className="border rounded bg-white shadow-sm mb-3">
      <div className="d-flex align-items-center p-3 client-card-header" onClick={() => setOpen(!open)}>
        {/* Expand Icon */}
        <Icon icon={open ? faChevronDown : faChevronRight} className="me-3 text-secondary" />

        {/* Client Name */}
        <div className="fw-semibold">{full_name}</div>

        {/* Status */}
        <StatusTag status={status} />

        {/* Service count */}
        <div className="text-muted ms-2">{services_count} services</div>

        {/* Spacing */}
        <div className="flex-grow-1" />

        {/* Claimed / Paid */}
        <div className="d-flex gap-4">
          <div>Claimed: {formatCurrency(total_claimed)}</div>
          <div>Govt. Contribution: {formatCurrency(total_gov_contribution_amount)}</div>
          <div>Co-Contribution: {formatCurrency(total_co_contribution_amount)}</div>
          <div
            className={classNames({
              'text-danger': total_paid < total_claimed,
            })}
          >
            Paid: {formatCurrency(total_paid)}
          </div>
        </div>
      </div>

      {/* Collapsed Content */}
      {open && (
        <div className="px-3 pb-3">
          <TableView id={`reconciliation-table-client-${client_id}`} columns={columns} data={items} readonly striped />
        </div>
      )}
    </div>
  );
};

export default ClientCard;
